class DateUtils {
    constructor() {}

    getTimeObjFromMS(ms) {
        return {
            days: String(Math.floor(ms / (1000 * 60 * 60 * 24))).padStart(2, '0'),
            hours: String(Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0'),
            minutes: String(Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0'),
            seconds: String(Math.floor((ms % (1000 * 60)) / 1000)).padStart(2, '0'),
        };
    }

    getTimeString(timeObj) {
        return (
            Object.keys(timeObj)
                .map((unit) => (timeObj[unit] !== '00' ? `${timeObj[unit]}${unit[0]}` : ''))
                .filter(Boolean)
                .join(':') + (timeObj.seconds === '00' ? `:${timeObj.seconds}s` : '')
        );
    }

    getCurrentUTCDate() {
        const now = new Date();
        return new Date(
            now.getUTCFullYear(),
            now.getUTCMonth(),
            now.getUTCDate(),
            now.getUTCHours(),
            now.getUTCMinutes(),
            now.getUTCSeconds()
        );
    }

    formatDate(date) {
        const dateComponents = date.split(/[\-T:]/);
        const day = parseInt(dateComponents[2]);
        const month = parseInt(dateComponents[1]) - 1; // Month is 0-indexed in JavaScript
        const year = parseInt(dateComponents[0]);
        const hour = parseInt(dateComponents[3]);
        const minute = parseInt(dateComponents[4]);
        const second = parseInt(dateComponents[5]?.split('.')?.[0]) || 0;

        return new Date(year, month, day, hour, minute, second);
    }
}

class DeliveryTime extends HTMLElement {
    PUBLIC_HOLIDAYS = 'https://date.nager.at/api/v3/PublicHolidays/'

    constructor() {
        super();
    }

    async connectedCallback() {
        this.minDays = parseInt(this.getAttribute('data-min')) || 0;
        this.maxDays = parseInt(this.getAttribute('data-max')) || 0;

        this.country = this.getAttribute('data-country');
        this.lang = this.getAttribute('data-lang');

        this.holidays = await this.getPublicHolidays();

        this.calculate();

        subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
            console.log('cart updated - recalculating delivery time');
            this.updateAttributes();
        });
    }

    toStandardDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    formattedDate(date) {
        const locale = this.lang || (this.country === 'it' ? 'it' : 'en');
        const formatter = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' });
        return formatter.format(date);
    }

    calculate() {
        const today = new DateUtils().getCurrentUTCDate();
        if (today.getHours() >= 12) {
            this.minDays += 1;
            this.maxDays += 1;
        }
        const workingDays = this.minDays;

        const estimatedDate = new Date(today.getTime());;
        estimatedDate.setDate(today.getDate() + workingDays);

        while (this.isWeekend(estimatedDate) || this.isHoliday(estimatedDate)) {
            estimatedDate.setDate(estimatedDate.getDate() + 1);
        }

        const dateRange = [];
        const currentDate = new Date(today.getTime());;

        while (currentDate < estimatedDate) {
            dateRange.push(this.toStandardDate(currentDate));
            currentDate.setDate(currentDate.getDate() + 1);
        }

        let workedDays = dateRange.map(date => {
            const d = new Date(date);
            return (this.isHoliday(d) || this.isWeekend(d)) ? 0 : 1;
        }).reduce((a, b) => a + b, 0);

        while (workedDays < workingDays) {
            currentDate.setDate(currentDate.getDate() + 1);
            if (!this.isWeekend(currentDate) && !this.isHoliday(currentDate))
                workedDays++;
        }

        this.minDate = new Date(currentDate.getTime());
        this.maxDate = new Date(currentDate.getTime());
        this.maxDate.setDate(currentDate.getDate() + (this.maxDays - this.minDays));
        while (this.isWeekend(this.maxDate) || this.isHoliday(this.maxDate)) {
            this.maxDate.setDate(this.maxDate.getDate() + 1);
        }

        document.querySelectorAll('[data-delivery-min]').forEach(element => {
            element.innerHTML = this.formattedDate(this.minDate);
        });

        document.querySelectorAll('[data-delivery-max]').forEach(element => {
            element.innerHTML = this.formattedDate(this.maxDate);
        });

        document.querySelectorAll('[data-delivery-attribute]').forEach(element => {
            element.value = this.formattedDate(this.minDate) + " to " + this.formattedDate(this.maxDate);
        });
    }

    updateAttributes() {
        console.log('updating delivery time attributes');
        document.querySelectorAll('[data-delivery-attribute]').forEach(element => {
            element.value = this.formattedDate(this.minDate) + " to " + this.formattedDate(this.maxDate);
        });
    }

    isWeekend(date) {
        const day = date.getDay();
        return day === 0 || day === 6;
    }

    isHoliday(date) {
        const formattedDate = date.toISOString().split('T')[0];
        return this.holidays.some(holiday => holiday.date === formattedDate);
    }

    async getPublicHolidays() {
        const currentYear = new Date().getFullYear();
        const response = await fetch(`${this.PUBLIC_HOLIDAYS}${currentYear}/${this.country}`);

        return await response.json();
    }

}
customElements.define('delivery-time', DeliveryTime);